import React from "react";

const Or = ({ styleOverride = {} }) => {
  return (
    <div className={"decorated"} style={styleOverride}>
      <span>OR</span>
    </div>
  );
};

export default Or;
